import { Component, OnInit, ChangeDetectorRef, NgZone , inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { first, debounceTime, lastValueFrom, Subject } from 'rxjs';

import { ToastrService } from 'ngx-toastr';
import { hasValue } from '../../shared/common-functions';
import { AuthenticationService } from '../../shared/services/authentication.service';

import { FormBuilder, FormGroup } from '@angular/forms';
import { SettingsService, StartupService, TokenService } from '../../core';
import { LogService } from '../../../app/shared/services/log.service'
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { NavService } from '../../shared/services/nav.service';
import { AuthService } from '../../shared/services/auth.service';
import { trimmedEmailValidator } from './trimmed-email.validator';
import { NotificationService } from '../../shared/components/notification/notification.service';
declare let require
import Swal from 'sweetalert2'

@Component({
    selector: 'app-login',
    styleUrls: ['./login.component.scss'],
    templateUrl: './login.component.html',
    standalone: false
})
export class LoginComponent implements OnInit {
    private notificationService = inject(NotificationService);
    loading: boolean = false;
    appLogo = environment.application.logo;
    appName = environment.application.name;
    appVersion = environment.application.version;

    public loginForm: FormGroup;
    private readonly _success = new Subject<string>();
    returnUrl: string;
    staticAlertClosed = false;
    successMessage: string;
    version: string = '';

    loginError:string="";
    loginUNPWErrorIndicator=false;

    constructor(
        private readonly fb: FormBuilder,
        private readonly router: Router,
        private readonly token: TokenService,
        private readonly route: ActivatedRoute,
        private readonly startup: StartupService,
        private readonly settings: SettingsService,
        private readonly authenticationService: AuthenticationService,
        private readonly toastr: ToastrService,
        private readonly logService: LogService,
        private readonly http: HttpClient,
        public navServices: NavService,
        private readonly auth: AuthService,
        private readonly cdr: ChangeDetectorRef,
        private readonly ngZone: NgZone
    ) {
       this.loginForm = this.fb.group(
            {
                UserName: ['',[trimmedEmailValidator]],
                Password: [''],
                EnterpriseKey: [''],
            },
            { validators: this.loginValidator }
            );
    }
    loginValidatorold(form: FormGroup) {
            const userName = form.get('UserName')?.value?.trim();
            const password = form.get('Password')?.value?.trim();
            const enterpriseKey = form.get('EnterpriseKey')?.value?.trim();

            const loginWithUserPass = userName && password;
            const loginWithEnterpriseKey = enterpriseKey;

            if (!loginWithUserPass && !loginWithEnterpriseKey) {
                return { noLoginMethod: true }; // None provided
            }

            // If user entered both login options → invalid
            if (loginWithUserPass && loginWithEnterpriseKey) {
                return { bothProvided: true };
            }

            return null;
            }

           loginValidator(form: FormGroup) {
                    const userNameCtrl = form.get('UserName');
                    const passwordCtrl = form.get('Password');
                    const enterpriseCtrl = form.get('EnterpriseKey');

                    const userName = userNameCtrl?.value?.trim();
                    const password = passwordCtrl?.value?.trim();
                    const enterpriseKey = enterpriseCtrl?.value?.trim();

                    const hasUserPass = !!userName || !!password;
                    const hasEnterprise = !!enterpriseKey;

                    // If both login methods entered => error shown on EnterpriseKey only
                    if (hasUserPass && hasEnterprise) {
                        enterpriseCtrl?.setErrors({ bothProvided: true });
                        userNameCtrl?.setErrors(null);
                        passwordCtrl?.setErrors(null);
                        return null;
                    }

                    // If logging via Username/Password
                    if (hasUserPass && !hasEnterprise) {
                        if (!userName) userNameCtrl?.setErrors({ requiredUserName: true });
                        if (!password) passwordCtrl?.setErrors({ requiredPassword: true });
                        enterpriseCtrl?.setErrors(null);

                        return null;
                    }

                    // If logging via Enterprise Key
                    if (hasEnterprise && !hasUserPass) {
                        enterpriseCtrl?.setErrors(null);
                         userNameCtrl?.setErrors(null);
                        passwordCtrl?.setErrors(null);
                        return null;
                    }

                    // Nothing entered: show all required
                    userNameCtrl?.setErrors({ requiredUserName: true });
                    passwordCtrl?.setErrors({ requiredPassword: true });
                    enterpriseCtrl?.setErrors({ requiredEnterprise: true });

                    return null;
                    }

 async onLogin() {
      this.loginError="";
    this.loginUNPWErrorIndicator=false;
    let response;
                if (this.loginForm.invalid) {
                    this.loginForm.markAllAsTouched();
                    return;
                }
                this.loading = true;

                const { UserName, Password, EnterpriseKey } = this.loginForm.value;

                

                if (UserName && Password) {
                    // 🔵 Login using Cognito Username/Password
                    try{
                    response = await this.auth.loginWithUsernamePassword(UserName, Password);
                       }
                    catch(error:any){
                        this.loginUNPWErrorIndicator= true
                        this.loginError=error.message || "Login failed , Please Check your Credential or contact your Admin"
                         this.toastr.error(error.message || "Login failed , Please Check your Credential or contact your Admin", "Error");
                 }
                }
                else if (EnterpriseKey) {
                    // 🔵 Login via Enterprise Key (your API or Cognito custom auth)
                    try{
                    response = await this.auth.loginWithEnterpriseKey(EnterpriseKey);
                    }
                    catch(error:any){
                         this.loginUNPWErrorIndicator= true
                        this.loginError=error.message || "Login failed , Please Check your Credential or contact your Admin"
                         
                        this.toastr.error(error.message || "Login failed , Please Check your Credential or contact your Admin", "Error");
                    }
                }
                this.loading = false;
                if (response) {
                    this.notificationService.startPollingAfterLogin();
                }
         }

    AmplifyLogin() {
        this.auth.loginWithAzureAD().catch(error => {
            console.error('Azure AD login failed:', error);
        });
    }
    private async _clearSessionCookie(): Promise<void> {
        try {
            await this.clearSessionCookie();
        }
        catch (e) {
            console.log(e);
        }
    }
    ngOnInit(): void {
        this.notificationService.stopPolling();
        void this._clearSessionCookie();
        if (sessionStorage.getItem('token')) {

            sessionStorage.removeItem('token');
            sessionStorage.removeItem('currentUser');
            sessionStorage.removeItem('usr');
            sessionStorage.removeItem('jwt');
            sessionStorage.removeItem('.AspNetCore.Session');
            localStorage.removeItem('ng2Idle.main.expiry');
            localStorage.removeItem('ng2Idle.main.idling');
            localStorage.clear();
            sessionStorage.clear();
        }
        setTimeout(() => (this.staticAlertClosed = true), 20000);
        this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';

        this._success.subscribe(message => (this.successMessage = message));
        this._success.pipe(debounceTime(5000)).subscribe(() => (this.successMessage = null));
        this.navServices.getVersion().subscribe({
            next: response => {
                console.log(response,"Version");
                this.ngZone.run(() => {
                    if (response?.data) {
                        this.version = response.data.version;
                    } else {
                        console.warn("Version not found in response!");
                    }
                    this.cdr.detectChanges();
                });
            },
            error: error => {
                console.error("Error fetching version", error);
            }
        });
    }
    deleteCookie(name: string): void {
        document.cookie = `${name}=; Max-Age=0; path=/; domain=localhost`;

    }

    async clearSessionCookie() {
        localStorage.clear();
        sessionStorage.clear();
        let apiurl = environment.apiRoot + 'api/Login/SignOut';
        await lastValueFrom(this.http.get(apiurl));
    }
    onSubmit() {
        const formData = this.loginForm.value;
        const securePassword = [];
        for (let i = 0; i < formData.Password.length; i++) {
            securePassword.push(formData.Password.charCodeAt(i));
        }
        formData.SecurePassword = securePassword;
        if (this.loginForm.invalid) {
            return;
        }
        this.loading = true;
        this.authenticationService
            .login({
                SecurePassword: formData.SecurePassword,
                Password: null,
                UserName: formData.UserName,
                Domain: formData.Domain,
            })
            .pipe(first())
            .subscribe({
                next: data => {
                    if (hasValue(data) && hasValue(sessionStorage.getItem('currentUser'))) {
                        setTimeout(() => {

                            this.loading = false;
                        }, 6000);
                        this.router.navigate([this.returnUrl]);

                        const userId = data.Id;
                        const userFullName = data.unique_name;
                        const userEmail = data.Email;
                        const UserRoleName = data.UserRoleName;

                        this.settings.setUser({
                            id: userId,
                            name: userFullName,
                            email: userEmail,
                            avatar: './assets/images/avatar.png',
                            role: data.UserRoleName,
                        });
                        if (hasValue(sessionStorage.getItem('token'))) {

                            const tokenData = sessionStorage.getItem('token');
                            this.token.set({ token: tokenData, userId, userFullName, UserRoleName });
                        }
                        this.startup.load().then(() => {
                            let url = this.token.referrer.url || '/';
                            if (url.includes('/auth')) {
                                url = '/';
                                this.loading = false;
                            }
                            this.logService.setUserFullName(userFullName);
                            this.logService.setUserRoleName(UserRoleName);
                            this.router.navigateByUrl(url);
                        }).catch(error => {
                            this.loading = false;
                            console.error('Error loading startup data:', error);
                        });
                    }
                    else {
                        setTimeout(() => {
                            this.loading = false;
                        }, 100);
                        this.loginForm.reset({ Domain: 'Select Domain' });
                        this.toastr.error('Login Failed Verify Your Username, Password or Domain.');
                    }
                },

                error: error => console.log('error', error),
    complete: () => { }
            });
    }
}
